import {
    onSelectSceneObject,
    onSceneObjectUpdate,
    onUpdateSavedObject,
    onDeleteSavedObject,
    onCreateSavedObject
} from './objectsModuleController';
import {
    onSceneObjectChange,
    showSceneObjectPreview,
    hideSceneObjectPreview,
    showDefaultCursor,
    hideDefaultCursor,
    showCreateObjectCursor,
    showHoverObjectCursor,
    reGenerateNavMeshforDebug
} from "./viewerModuleController";
import { MSG_CODE } from '../constants';
import { v4 as uuidV4 } from 'uuid';
import { Vector3 } from 'three';
import {
    getAgoraUserIdByPhotoId,
    // sendDeleteSceneObjectFromNetwork,
    // setQuadrantData
} from './networkingModuleController';
import { packTransform, toBase64 } from '../utils';
let navigationModule;
let physicsReady = true;

let navigationPromises = {};

let options;

export function setupDOMNavigationModuleController(_options) {
    options = _options;
}

export function setNavigationModule(_navigationModule) {
    navigationModule = _navigationModule;
}

export function initNavigationModule(args) {
    return new Promise((resolve, reject) => {
        if (navigationModule) {
            navigationModule.init({
                camera: args.camera,
                inputElement: args.inputElement,
                THREE: args.THREE,
                clock: args.clock,
                scene: args.scene
            });

            navigationModule.initPhysics({
                scene: args.sceneryGroup,
                sceneObjectsGroup: args.sceneObjectsGroup,
                collider: args.collisionGroup,
                navMeshGroup: args.navMeshGroup,
                navMeshLayer: args.navMeshLayer,
                creationSurfaceGroup: args.creationSurfaceGroup,
                creationSurfaceLayer: args.creationSurfaceLayer,
                collisionLayer: args.collisionLayer,
                sceneObjectsLayer: args.sceneObjectsLayer,
                useNewPathfinding: args.useNewPathfinding
            }).then(() => {
                physicsReady = true;

                cleanupNavigationEvents();

                registerNavigationEvents();

                resolve();
            });
        } else {
            reject();
        }
    });
}

function registerNavigationEvents() {
    navigationModule.subscribe('playerMovement', onPlayerMove);
    navigationModule.subscribe('playerRotation', onPlayerRotate);
    navigationModule.subscribe('onUpdateSceneObject', onSceneObjectUpdate);
    navigationModule.subscribe('onSelectSceneObject', onSelectSceneObject);
    navigationModule.subscribe('onChangeSceneObject', onSceneObjectChange);
    navigationModule.subscribe('sendHostAction', onHostAction);
    navigationModule.subscribe('finishPathfindingMovement', onFinishPathfindingMovement);
    navigationModule.subscribe('actionPositionIndicator', onIndicatorPositionUpdate);
    navigationModule.subscribe('previewIndicatorRaycast', onPreviewIndicatorPositionUpdate);
    navigationModule.subscribe('hidePreview', onHidePreview);
    navigationModule.subscribe('defaultCursorRaycast', onDefaultCursorPositionUpdate);
    navigationModule.subscribe('hideDefaultCursorRaycast', onHideDefaultCursorPositionUpdate);
    navigationModule.subscribe('createObjectCursorRaycast', onCreateObjectCursor);
    navigationModule.subscribe('hoverObjectCursorRaycast', onHoverObjectCursor);
    navigationModule.subscribe('moveWithPathfindingFinished', onMoveWithPathfindingFinished);
    navigationModule.subscribe('rotateCamera', onRotateCamera);
    navigationModule.subscribe('rotateCameraAzureAngle', onRotateCameraAzureAngle);
    navigationModule.subscribe('updateSavedObject', onUpdateSavedObject);
    navigationModule.subscribe('deleteSavedObject', onDeleteSavedObject);
    navigationModule.subscribe('createSavedObject', onCreateSavedObject);
    navigationModule.subscribe('generateNewNavMesh', onGenerateNewNavMesh);
    navigationModule.subscribe('remoteInView', onRemoteLinkipadInView);
    navigationModule.subscribe('objectCreationCanceled', onObjectCreationCanceled);
    navigationModule.subscribe('myInterestGroupEvent', onMyInterestGroupEvent);
}

function cleanupNavigationEvents() {
    navigationModule.unsubscribe('playerMovement', onPlayerMove);
    navigationModule.unsubscribe('playerRotation', onPlayerRotate);
    navigationModule.unsubscribe('onUpdateSceneObject', onSceneObjectUpdate);
    navigationModule.unsubscribe('onSelectSceneObject', onSelectSceneObject);
    navigationModule.unsubscribe('onChangeSceneObject', onSceneObjectChange);
    navigationModule.unsubscribe('sendHostAction', onHostAction);
    navigationModule.unsubscribe('finishPathfindingMovement', onFinishPathfindingMovement);
    navigationModule.unsubscribe('actionPositionIndicator', onIndicatorPositionUpdate);
    navigationModule.unsubscribe('previewIndicatorRaycast', onPreviewIndicatorPositionUpdate);
    navigationModule.unsubscribe('hidePreview', onHidePreview);
    navigationModule.unsubscribe('defaultCursorRaycast', onDefaultCursorPositionUpdate);
    navigationModule.unsubscribe('hideDefaultCursorRaycast', onHideDefaultCursorPositionUpdate);
    navigationModule.unsubscribe('createObjectCursorRaycast', onCreateObjectCursor);
    navigationModule.unsubscribe('hoverObjectCursorRaycast', onHoverObjectCursor);
    navigationModule.unsubscribe('moveWithPathfindingFinished', onMoveWithPathfindingFinished);
    navigationModule.unsubscribe('rotateCamera', onRotateCamera);
    navigationModule.unsubscribe('rotateCameraAzureAngle', onRotateCameraAzureAngle);
    navigationModule.unsubscribe('updateSavedObject', onUpdateSavedObject);
    navigationModule.unsubscribe('deleteSavedObject', onDeleteSavedObject);
    navigationModule.unsubscribe('createSavedObject', onCreateSavedObject);
    navigationModule.unsubscribe('generateNewNavMesh', onGenerateNewNavMesh);
    navigationModule.unsubscribe('remoteInView', onRemoteLinkipadInView);
    navigationModule.unsubscribe('objectCreationCanceled', onObjectCreationCanceled);
    navigationModule.unsubscribe('myInterestGroupEvent', onMyInterestGroupEvent);

}

export function onObjectCreationCanceled() {
    let msg = {
        code: MSG_CODE.OBJECT_CREATION_CANCELED
    }
    postMessage(msg);
}

function onMyInterestGroupEvent(data) {

    let msg = {
        code: "onQuadrantData",
        data: data
    }
    postMessage(msg);

    forceGetPositionAndRotation();
}

export function onRemoteLinkipadInView(data) {
    let msg = {
        code: MSG_CODE.REMOTE_IN_VIEW,
        data: data
    }
    postMessage(msg);
}

export function onGenerateNewNavMesh(data) {
    // console.log("onGenerateNewNavMesh", data);
    reGenerateNavMeshforDebug(data);
}

export function onPlayerMoveSubcribe(value) {
    if (navigationModule) {
        if (value) {
            navigationModule.subscribe('playerMovement', onPlayerMove);
            navigationModule.subscribe('playerRotation', onPlayerRotate);
        }
        else {
            navigationModule.unsubscribe('playerMovement', onPlayerMove);
            navigationModule.unsubscribe('playerRotation', onPlayerRotate);
        }
    }
}

function onPlayerMove(data) {

    const type = "position";

    let posXstr = data.x.toFixed(2);
    let posXnum = parseFloat(posXstr);

    let posYstr = data.y.toFixed(2);
    let posYnum = parseFloat(posYstr);

    let posZstr = data.z.toFixed(2);
    let posZnum = parseFloat(posZstr);

    var buf = packTransform(type, { x: posXnum, y: posYnum, z: posZnum })

    let msg = {
        code: MSG_CODE.NETWORKING_SEND_LINKPAD_TRANSFORM,
        data: { type: type, payload: toBase64(buf) }
    }
    postMessage(msg);
}

function onPlayerRotate(data) {

    const type = "rotation";

    let rotXstr = data.x.toFixed(2);
    let rotXnum = parseFloat(rotXstr);

    let rotYstr = data.y.toFixed(2);
    let rotYnum = parseFloat(rotYstr);

    let rotZstr = data.z.toFixed(2);
    let rotZnum = parseFloat(rotZstr);

    let rotWstr = data.w.toFixed(2);
    let rotWnum = parseFloat(rotWstr);

    var buf = packTransform(type, { x: rotXnum, y: rotYnum, z: rotZnum, w: rotWnum })

    let msg = {
        code: MSG_CODE.NETWORKING_SEND_LINKPAD_TRANSFORM,
        data: { type: type, payload: toBase64(buf) }
    }
    postMessage(msg);
}

export function onPreviewIndicatorPositionUpdate(data) {
    showSceneObjectPreview(data);
}

export function onHidePreview() {
    hideSceneObjectPreview();
}

export function onDefaultCursorPositionUpdate(data) {
    showDefaultCursor(data);
}

export function onHideDefaultCursorPositionUpdate() {
    hideDefaultCursor();
}

export function onCreateObjectCursor(data) {
    showCreateObjectCursor(data);
}

export function onHoverObjectCursor() {
    showHoverObjectCursor();
}

export function setTransformMode(mode) {
    navigationModule.setMode(mode);
}


export function getSelectedSceneObject(_uuid) {
    return new Promise((resolve, reject) => {
        try {
            //DOM          
            let validate = window;

            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };

            let msg = {
                code: 'navigation_selected_sceneObject',
                data: {
                },
                uuid: uuidPromise
            }

            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {

            //OffScreen
            let msg = {
                code: 'navigationResolve',
                data: navigationModule.getCurrentSceneObject() != undefined ? navigationModule.getCurrentSceneObject().userData : undefined,
                uuid: _uuid
            }

            postMessage(msg);
        }
    })
}

export function getSceneObject(_uuid) {
    return new Promise((resolve, reject) => {
        try {
            //DOM          
            let validate = window;

            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };

            let msg = {
                code: 'getSceneObject',
                data: {
                },
                uuid: uuidPromise
            }

            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {

            //OffScreen
            let msg = {
                code: 'navigationResolve',
                data: navigationModule.getCurrentSceneObject().userData,
                uuid: _uuid
            }

            postMessage(msg);
        }
    })
}


export function getNavigationRaycast(_uuid) {
    return new Promise((resolve, reject) => {
        try {
            //DOM          
            let validate = window;

            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };

            let msg = {
                code: 'createRaycast',
                data: {
                },
                uuid: uuidPromise
            }

            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {
            //OffScreen
            navigationModule.createRaycastForNewObject().then((intersection) => {
                let msg = {
                    code: 'navigationResolve',
                    data: intersection,
                    uuid: _uuid
                }

                postMessage(msg);
            }).catch((e) => {
                let msg = {
                    code: 'navigationReject',
                    data: e,
                    uuid: _uuid
                }

                postMessage(msg);
            });
        }
    })
}

export function getPlayerHeight(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;

            const promiseUuid = uuidV4();
            navigationPromises[promiseUuid] = { resolve, reject };

            let msg = {
                code: 'getPlayerHeight',
                data: {},
                uuid: promiseUuid
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            if (navigationModule) {
                navigationModule.getPlayerHeight().then((height) => {

                    let msg = {
                        code: 'navigationResolve',
                        data: height,
                        uuid: _msg.uuid
                    }
                    postMessage(msg);
                })
            }
        }
    });
}

export function toggleQuadrants(_msg) {

    return new Promise((resolve, reject) => {
        try {
            let validate = window;

            const promiseUuid = uuidV4();
            navigationPromises[promiseUuid] = { resolve, reject };

            let msg = {
                code: 'toggleQuadrants',
                data: {},
                uuid: promiseUuid
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            if (navigationModule) {
                navigationModule.toggleQuadrants().then((height) => {

                    let msg = {
                        code: 'navigationResolve',
                        data: height,
                        uuid: _msg.uuid
                    }
                    postMessage(msg);
                })
            }
        }
    });

}



export function forceSelectSceneObject(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;

            const promiseUuid = uuidV4();
            navigationPromises[promiseUuid] = { resolve, reject };

            let msg = {
                code: 'forceSelectSceneObject',
                data: _msg.data,
                uuid: promiseUuid
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            if (navigationModule) {
                navigationModule.forceSelectSceneObject(_msg.data).then((height) => {

                    let msg = {
                        code: 'navigationResolve',
                        data: {},
                        uuid: _msg.uuid
                    }
                    postMessage(msg);
                })
            }
        }
    });
}


export function snapCurrentSceneObject(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const promiseUuid = uuidV4();
            navigationPromises[promiseUuid] = { resolve, reject };
            let msg = {
                code: 'snapCurrentSceneObject',
                data: _msg.data,
                uuid: promiseUuid
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            if (navigationModule) {
                navigationModule.snapCurrentSceneObject(_msg).then(() => {

                    let msg = {
                        code: 'navigationResolve',
                        data: {},
                        uuid: _msg.uuid
                    }
                    postMessage(msg);
                })
            }
        }
    });
}

export function setEnableTransformControls(_msg) {
    return new Promise((resolve, reject) => {

        try {
            let validate = window;
            const promiseUuid = uuidV4();
            navigationPromises[promiseUuid] = { resolve, reject };
            let msg = {
                code: 'setEnableTransformControls',
                data: _msg.data,
                uuid: promiseUuid
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            if (navigationModule) {
                navigationModule.setEnableTransformControls(_msg).then(() => {

                    let msg = {
                        code: 'navigationResolve',
                        data: {},
                        uuid: _msg.uuid
                    }
                    postMessage(msg);
                })
            }
        }



    });
}


export function enablePlayerMovementAndRotation(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;

            const promiseUuid = uuidV4();
            navigationPromises[promiseUuid] = { resolve, reject };

            let msg = {
                code: 'enablePlayerMovementAndRotation',
                data: _msg.data,
                uuid: promiseUuid
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.enablePlayerMovementAndRotation(_msg).then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })
        }
    });
}

export function setCurrentSceneObject(_msg) {
    return new Promise((resolve, reject) => {
        try {
            //DOM          
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };

            let msg = {
                code: 'setCurrentSceneObject',
                data: { uuid: _msg.data.uuid },
                uuid: uuidPromise
            }

            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {
            navigationModule.setCurrentSceneObject(_msg.data.uuid).then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })
        }
    })
}

export function focusToSceneObject(_msg) {
    return new Promise((resolve, reject) => {
        try {
            //DOM      
            let validate = window;
            const uuidPromise = uuidV4();

            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'focusToSceneObject',
                data: { uuid: _msg.data.uuid },
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {
            onPlayerMoveSubcribe(false);
            navigationModule.focusToSceneObject(_msg.data.uuid).then(() => {

                let msg = {
                    code: 'navigationResolve',
                    data: { uuid: _msg.data.uuid },
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })
        }
    })
}

export function orbitToSceneObject(_msg) {
    return new Promise((resolve, reject) => {
        try {
            //DOM      
            let validate = window;
            const uuidPromise = uuidV4();

            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'orbitToSceneObject',
                data: { uuid: _msg.data.uuid },
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {
            onPlayerMoveSubcribe(false);
            navigationModule.orbitToSceneObject(_msg.data.uuid).then(() => {

                let msg = {
                    code: 'navigationResolve',
                    data: { uuid: _msg.data.uuid },
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })
        }
    })
}

export function exitOrbitMode(_msg) {
    return new Promise((resolve, reject) => {
        try {
            //DOM      
            let validate = window;
            const uuidPromise = uuidV4();

            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'exitOrbitMode',
                data: {},
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {
            onPlayerMoveSubcribe(true);
            navigationModule.exitOrbitMode(_msg).then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })
        }
    })
}

export function enableMirrorFollowMe(_msg) {
    return new Promise((resolve, reject) => {
        try {
            //DOM      
            let validate = window;
            const uuidPromise = uuidV4();

            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'enableMirrorFollowMe',
                data: _msg.data,
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {
            navigationModule.enableMirrorFollowMe(_msg.data).then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })
        }
    })
}

export function moveToPosition(_msg) {
    return new Promise((resolve, reject) => {
        try {
            //DOM      
            let validate = window;
            const uuidPromise = uuidV4();

            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: MSG_CODE.ACTION_MOVE_TO,
                data: _msg.data,
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {
            moveToTarget(_msg.data).then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            }).catch(() => {
                let msg = {
                    code: 'navigationReject',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            });
        }
    })
}


export function cancelMoveToPosition() {
    return new Promise((resolve, reject) => {
        try {
            //DOM      
            let validate = window;
            const uuidPromise = uuidV4();

            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: "cancelMoveToPosition",
                data: {},
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {
            navigationModule.cancelMoveToTarget();
            // moveToTarget(_msg.data).then(() => {
            //     let msg = {
            //         code: 'navigationResolve',
            //         data: {},
            //         uuid: _msg.uuid
            //     }
            //     postMessage(msg);
            // });
        }
    })
}


export function lookAtPosition(_msg) {
    return new Promise((resolve, reject) => {
        try {
            //DOM      
            let validate = window;
            const uuidPromise = uuidV4();

            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: MSG_CODE.ACTION_LOOKTO_ORDER,
                data: _msg.data,
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {
            lookAtTarget(_msg.data.positionLook).then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            });
        }
    })
}

export function rotateCamera360(_msg) {
    return new Promise((resolve, reject) => {
        try {
            //DOM      
            let validate = window;
            const uuidPromise = uuidV4();

            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: MSG_CODE.ACTION_ROTATE_360,
                data: {},
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {
            start360CameraRotation().then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            }).catch(() => {
                let msg = {
                    code: 'navigationReject',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            });
        }
    })
}

export function cancelRotateCamera360(_msg) {
    return new Promise((resolve, reject) => {
        try {
            //DOM      
            let validate = window;
            const uuidPromise = uuidV4();

            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: "cancelRotateCamera360",
                data: { status: true },
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.cancel360CameraRotation(_msg.data);
        }
    })
}



export function navigationResolve(msg) {
    navigationPromises[msg.uuid].resolve(msg.data);
}

export function navigationReject(msg) {
    navigationPromises[msg.uuid].reject(msg.data);
}

export function getPlayerPosition() {
    let pos = navigationModule.getCameraPosition();
    let msg = {
        code: MSG_CODE.ACTION_RECIVE_POSITION,
        data: { position: pos }
    }
    postMessage(msg);
}



function moveToTarget(data) {
    return new Promise((resolve, reject) => {
        const posv3 = new Vector3(data.position.x, data.position.y, data.position.z);
        navigationModule.moveToTarget(posv3).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });

    });
}

function lookAtTarget(position) {
    return new Promise((resolve, reject) => {
        const posv3 = new Vector3(position.x, position.y, position.z);
        navigationModule.lookAtTarget(position).then(() => {
            resolve();
        });
    });
}

export function movePlayerInmediatlyTo(position) {
    if (navigationModule) {
        navigationModule.movePlayerInmediatlyTo(position);
    }
}


export function lookAtTargetInmediatly(lookAt) {
    if (navigationModule) {
        navigationModule.lookAtTargetInmediatly(lookAt);
    }
}

export function actionOrbitToSceneObject(uuid) {
    if (navigationModule) {
        navigationModule.orbitToSceneObject(uuid);
    }
}

export function actionOrbitToPosition(position) {
    if (navigationModule) {
        onPlayerMoveSubcribe(false);
        navigationModule.orbitToPosition(position);
    }
}

export function actionExitOrbit() {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const promiseUuid = uuidV4();
            navigationPromises[promiseUuid] = { resolve, reject };

            let msg = {
                code: 'actionExitOrbit',
                data: {},
                uuid: promiseUuid
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {
            if (navigationModule) {
                onPlayerMoveSubcribe(true);
                navigationModule.exitOrbitMode();
            }
        }
    });
}

function start360CameraRotation() {
    return new Promise((resolve, reject) => {
        if (navigationModule) {
            navigationModule.start360CameraRotation().then(() => {
                resolve();
            }).catch(() => {
                reject();
            });
        }
    });
}

export function forceUnselectSceneObject(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;

            const promiseUuid = uuidV4();
            navigationPromises[promiseUuid] = { resolve, reject };

            let msg = {
                code: 'forceUnselectSceneObject',
                data: {},
                uuid: promiseUuid
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {

            navigationModule.forceUnselectSceneObject().then(() => {

                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })


        }

    });
}

export function onFinishPathfindingMovement() {
    let msg = {
        code: MSG_CODE.ACTION_FINISH_PATHFINDING_MOVEMENT,
        data: {}
    }
    postMessage(msg);
}

export function onMoveWithPathfindingFinished() {
    let msg = {
        code: MSG_CODE.MOVE_WITH_PATHFINDING_FINISHED,
        data: {}
    }
    postMessage(msg);
}

export function onRotateCamera() {
    let msg = {
        code: MSG_CODE.ROTATE_CAMERA,
        data: {}
    }
    postMessage(msg);
}

export function onRotateCameraAzureAngle(data) {
    let msg = {
        code: MSG_CODE.ROTATE_CAMERA_AZIMUTH_ANGLE,
        data: data,
    }
    postMessage(msg);
}

export function onHostAction(_msg) {
    let msg = {
        code: MSG_CODE.RECIVED_ACTION,
        data: _msg,
    }

    postMessage(msg);
}

export function onIndicatorPositionUpdate(_msg) {
    let msg = {
        code: MSG_CODE.ACTION_POSITION_INDICATOR,
        data: _msg,
    }
    postMessage(msg);
}

export function setCurrentAction(_msg) {
    return new Promise((resolve, reject) => {
        try {
            //DOM          
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };

            let msg = {
                code: 'set_current_action',
                data: {
                    action: _msg.action
                },
                uuid: uuidPromise
            }

            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {

            //OffScreen
            navigationModule.setCurrentAction(_msg.data.action);
            // let msg = {
            //     code: 'navigationResolve',
            //     data: navigationModule.getCurrentSceneObject().userData,
            //     uuid: _uuid
            // }

            // postMessage(msg);
        }
    })
}
export function setSelectedUsers(_msg) {
    return new Promise((resolve, reject) => {
        try {
            //DOM          
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'set_selected_users',
                data: {
                    users: _msg.selectedUsers
                },
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {

            //OffScreen
            navigationModule.setSelectedUsers(_msg.data.users);
            // let msg = {
            //     code: 'navigationResolve',
            //     data: navigationModule.getCurrentSceneObject().userData,
            //     uuid: _uuid
            // }

            // postMessage(msg);
        }
    })
}
export function changeState(_msg) {
    navigationModule.changeState(_msg.data.state);
}

export function navigateToUser(userId) {
    const user = getAgoraUserIdByPhotoId(userId)
    options.workers.offscreenCanvasWorker.postMessage({ code: "getRemoteLinkpadPosition", data: user });
}

export function selectSceneObject(uuid) {
    return new Promise((resolve, reject) => {
        forceSelectSceneObject({ data: { uuid: uuid } }).then(() => {
            resolve();
        })
    });
}
// export function goToSceneObject(_msg) {

//     return new Promise((resolve, reject) => {
//         try {
//             //DOM          
//             let validate = window;

//             const uuidPromise = uuidV4();
//             navigationPromises[uuidPromise] = { resolve, reject };

//             let msg = {
//                 code: 'goToSceneObject',
//                 data: { obj: _msg },
//                 uuid: uuidPromise
//             }

//             options.workers.offscreenCanvasWorker.postMessage(msg);
//         } catch (error) {

//             var obj = navigationModule.getSizeObject(_msg.obj);
//             console.log(obj);
//             obj.setRotationFromEuler(new THREE.Euler());
//             var box = new THREE.Box3().setFromObject(obj);
//             var centerPosition = new THREE.Vector3();
//             box.getCenter(centerPosition);
//             var object3DHeight = (box.max.y - box.min.y) / 2;
//             const posObj = new Vector3(_msg.data.data.position[0], centerPosition.y + object3DHeight, _msg.data.data.position[2]);
//             navigationModule.checkIntersectionsAroundObject(posObj);
//         }
//     })
//     // options.workers.offscreenCanvasWorker.postMessage({ code: "goToSceneObject", data: {uuid: uuid} });
//     // navigationModule.goToSceneObject(uuid);
//     // console.log(getSelectedSceneObject(uuid));
//     //navigationModule.goToSceneObject();
// }

export function inputKeyNavigation(_msg) {
    return new Promise((resolve, reject) => {
        try {
            //DOM          
            let validate = window;

            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };

            let msg = {
                code: 'inputKeyNavigation',
                data: _msg.data,
                uuid: uuidPromise
            }

            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {
            //OffScreen
            /*
            let msg = {
                code: 'navigationResolve',
                data: _msg.data,
                uuid: _msg
            }
            postMessage(msg);
            */
            navigationModule.inputKey(_msg.data);
        }
    })
}

export function cancelNavigateToObject(_msg) {
    return new Promise((resolve, reject) => {
        try {
            //DOM          
            let validate = window;

            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };

            let msg = {
                code: 'cancelNavigateToObject',
                data: {},
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {
            navigationModule.cancelNavigateToObject(_msg.data);
        }
    });
}

export function forceGetPositionAndRotation(_msg) {
    return new Promise((resolve, reject) => {
        try {
            //DOM          
            let validate = window;

            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };

            let msg = {
                code: 'forceGetPositionAndRotation',
                data: {},
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {
            navigationModule.forceGetPositionAndRotation();
        }
    });
}


export function focusView(_msg) {
    return new Promise((resolve, reject) => {
        try {
            //DOM          
            let validate = window;

            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };

            let msg = {
                code: 'focusView',
                data: _msg.data,
                uuid: uuidPromise
            }

            options.workers.offscreenCanvasWorker.postMessage(msg);
        } catch (error) {
            navigationModule.focusView(_msg.data).then(() => { });
        }
    })
}

export function getCurrentOrbitUuid(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'getCurrentOrbitUuid',
                data: {},
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.getCurrentOrbitUuid().then((res) => {
                let msg = {
                    code: 'navigationResolve',
                    data: {
                        res
                    },
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })

        }

    });
}

export function getCurrentFocusUuid(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'getCurrentFocusUuid',
                data: {},
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.getCurrentFocusUuid().then((res) => {
                let msg = {
                    code: 'navigationResolve',
                    data: {
                        res
                    },
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })

        }

    });
}

export function ghostMode(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'ghostMode',
                data: {},
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.ghostMode().then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })

        }

    });
}

export function resetGhostMode(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'resetGhostMode',
                data: {},
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.resetGhostMode().then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })

        }

    });
}

export function clearTransformControllerSceneObjects(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'clearTransformControllerSceneObjects',
                data: {},
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.clearTransformControllerSceneObjects().then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })

        }

    });
}

export function orbitZoomIn(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'orbitZoomIn',
                data: {},
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.orbitZoomIn().then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })

        }

    });
}


export function orbitZoomOut(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'orbitZoomOut',
                data: {},
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.orbitZoomOut().then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })

        }

    });
}

export function undo(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'undo',
                data: {},
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.undo().then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })

        }

    });
}

export function redo(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'redo',
                data: {},
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.redo().then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })

        }

    });
}

export function saveHistoryCreateState(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'saveHistoryCreateState',
                data: _msg,
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.saveHistoryCreateState(_msg).then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })

        }

    });
}

export function saveHistoryDeleteState(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'saveHistoryDeleteState',
                data: _msg,
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.saveHistoryDeleteState(_msg).then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })

        }

    });
}

export function resetSceneObjectScale(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'resetSceneObjectScale',
                data: { uuid: _msg.data.uuid },
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.resetSceneObjectScale(_msg.data.uuid).then(() => {
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })

        }
    });
}

export function generateNewNavmesh(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'generateNewNavmesh',
                data: _msg,
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.generateNewNavmesh(_msg).then((newMesh) => {
                reGenerateNavMeshforDebug(newMesh);
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })

        }

    });
}

export function onLoadSceneObjectsFromDBDone(_msg) {
    return new Promise((resolve, reject) => {
        try {
            let validate = window;
            const uuidPromise = uuidV4();
            navigationPromises[uuidPromise] = { resolve, reject };
            let msg = {
                code: 'onLoadSceneObjectsFromDBDone',
                data: { sceneObjects: _msg.data.sceneObjects },
                uuid: uuidPromise
            }
            options.workers.offscreenCanvasWorker.postMessage(msg);

        } catch (error) {
            navigationModule.onLoadSceneObjectsFromDBDone(_msg.data.sceneObjects).then((newMesh) => {
                reGenerateNavMeshforDebug(newMesh);
                let msg = {
                    code: 'navigationResolve',
                    data: {},
                    uuid: _msg.uuid
                }
                postMessage(msg);
            })

        }

    });
}